import React from 'react'
import { makeObservable, observable } from 'mobx'

class UniqueUserStore {
    constructor(store) {
        makeObservable(this)
        this.store = store
    }

    @observable data = []

    @observable isResultFetched = false

    columns = [
        {
            key: 'unique',
            name: 'Unique',
        },
        {
            key: 'active',
            name: 'Active',
        },
        {
            key: 'pct',
            name: 'Pct',
            dataTransform: (pct) => (
                <p>
                    {' '}
                    {pct.toFixed(2)}
                    {' '}
                    %
                    {' '}
                </p>
            ),
        },
    ]

    @observable request = {
        startDate: null,
        endDate: null,
    }

    handleChangeRequest = ({ value }, date) => {
        console.log('handleChangeRequest', value)
        if (date === 'start') {
            this.request.startDate = value.format('YYYY-MM-DD')
        } else {
            this.request.endDate = value.format('YYYY-MM-DD')
        }
    }

    validateDate = () => {
        if (!this.request.startDate) {
            throw new Error('Insert a Starting Date')
        } else if (!this.request.endDate) {
            throw new Error('Insert a End Date')
        }
    }

    getUniqueUsers = async () => {
        try {
            this.data = []
            this.validateDate()
            const res = await this.store.http.post('/intranet/systemUniqueUsers', JSON.stringify(this.request))
            this.data.push(res)
            this.isResultFetched = true
        } catch (e) {
            this.store.handleError({ body: `something went wrong: ${e.message}`, level: 'error' })
        }
    }
}

export default UniqueUserStore
